import Cookies from 'js-cookie';
import { AxiosInstance } from 'axios';
import createAuthRefreshInterceptor from 'refresh';
import { authStorage } from 'storages';
import { AuthConfigInterface } from 'app/services/AuthService/AuthConfigInterface';
import { generateUuid } from 'shared/utils/uuid';
import { setAuthClientId } from 'shared/utils';
import { createRefreshAuthLogic } from './createRefreshAuthLogic';

export const setAxiosAuthInterceptor = (
  axiosInstance: AxiosInstance,
  authConfig: AuthConfigInterface,
  useXRequestIdHeader?: boolean,
) => {
  setAuthClientId(authConfig.clientId);

  axiosInstance.interceptors.request.use(config => {
    if (config.headers) {
      if (!config.headers.Accept) {
        config.headers.Accept = 'application/json';
      }

      if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
      }

      if (useXRequestIdHeader) {
        config.headers['X-Request-ID'] = generateUuid();
      }

      const authParams = authStorage.getJwtAuthParams();
      if (authParams?.access) {
        config.headers.Authorization = `Bearer ${authParams.access}`;
      }

      const csrftoken = Cookies.get('csrftoken');
      if (csrftoken) {
        config.headers['X-CSRFToken'] = csrftoken;
      }
    }

    return config;
  });

  const { refreshAuthLogic } = createRefreshAuthLogic(authConfig);

  createAuthRefreshInterceptor(axiosInstance, refreshAuthLogic, {
    statusCodes: [401],
  });
};
